<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Row>
        <Form>
          <Col :span="6">
            <Button type="primary" @click="createNewSupplies">新建</Button>
          </Col>
        </Form>
      </Row>
      <Table
        :loading="SuppliesLoading"
        :columns="SuppliesColumns"
        :data="SuppliesData"
        @on-selection-change="SuppliesSelectionChange"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" ghost size="small" style="margin-right: 5px;color: #2b85e4" @click="editSupplies(row)">
            修改
          </Button>
          <Button type="text" ghost size="small" style="color: red" @click="removeSupplies(row)">删除</Button>
        </template>
      </Table>
      <Button type="error" style="float: left;margin-top: 10px" @click="delList">删除</Button>
      <Page style="float: right;margin-top: 10px"
            show-sizer
            show-total
            :total="SuppliesTotal"
            :page-size="SuppliesPageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="SuppliesCurrentPage"
            @on-change="SuppliesPageChange"
            @on-page-size-change="SuppliesPageSizeChange"
      ></Page>
    </Card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      SuppliesLoading: true,
      SuppliesSelection: [],
      SuppliesTotal: 0,
      SuppliesColumns: [
        {type: 'selection', width: 60, align: 'center'},
        {title: '物资名称', key: 'name', align: 'center'},
        {title: '单位', key: 'unit', align: 'center'},
        {title: '物资数量', key: 'goodsNumber', align: 'center'},
        {title: '备注', key: 'remark', align: 'center'},
        {
          title: '生效日期', key: 'effectiveDate', align: 'center', render: (h, params) => {
            return h('span', {}, params.row.effectiveDate ? this.$moment(params.row.effectiveDate).format('YYYY-MM-DD') : '')
          }
        },
        // {title: '适用事件类型', key: 'applicableEventTypes', align: 'center'},
        {title: '操作', slot: 'action', width: 150, align: 'center'}
      ],
      SuppliesData: [],
      SuppliesPageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      SuppliesCurrentPage: 1,
    }
  },
  mounted() {
    this.getSuppliesData()
  },
  methods: {
    getSuppliesData() {
      this.$http.post(`/api/goodsConfig/getAll?page=${this.SuppliesCurrentPage}&size=${this.SuppliesPageSize}`, {}).then(res => {
        if (res.status === 200) {
          this.SuppliesLoading = false
          this.SuppliesData = res.data.data.list
          this.SuppliesTotal = res.data.data.total
        }
      })
    },
    editSupplies(row) {
      this.$router.push({name: 'createSupplies', query: {id: row.id}})
    },
    SuppliesSelectionChange(selection) {
      this.SuppliesSelection = selection
    },
    delList() {
      if (this.SuppliesSelection.length === 0) {
        this.$Message.warning('请选择要删除的物资')
        return
      }
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确定删除选中的物资吗？</p>',
        onOk: () => {
          let requestData = []
          this.SuppliesSelection.forEach(item => {
            requestData.push(item.id)
          })
          this.$http.post(`/api/goodsConfig/delete`, requestData).then(res => {
            if (res.status === 200) {
              this.$Message.success('删除成功')
              this.getSuppliesData()
            }
          })
        }
      })
    },
    removeSupplies(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确定删除该物资吗？</p>',
        onOk: () => {
          let requestData = [row.id]
          this.$http.post(`/api/goodsConfig/delete`, requestData).then(res => {
            if (res.status === 200) {
              this.$Message.success('删除成功')
              this.getSuppliesData()
            }
          })
        }
      })
    },
    createNewSupplies() {
      this.$router.push({name: 'createSupplies'})
    },
    SuppliesPageChange(page) {
      this.SuppliesCurrentPage = page
      this.getSuppliesData()
    },
    SuppliesPageSizeChange(pageSize) {
      this.SuppliesPageSize = pageSize
      this.getSuppliesData()
    }
  },
}
</script>
<style scoped>

</style>
